import ReactStrapTable from 'components/reactStrapTable';
import React, { useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { dateFormate, cellRendererCheck } from 'utils/columns';
import { Formik } from 'formik';
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import Confirm from 'components/Confirm';
import useAxios from 'hooks/useAxios';
import { toast } from 'react-toastify';
import { ModuleAccess } from 'utils/moduleaccess';
import { cloneDeep } from 'lodash';



let tableDataBackup = [
    {
        chainPharmacy:"123445",
        pharmacy:"123445",
        npi:"123445",
        ncpdPandNABP:"123445",
        pharmacyAddress:"123445",
        pharmacyLiveDate:"123445",
        pharmacyTerminationDate:"123445",
        claimsProcessDate:"123445",

    }
];
let rowForEdit = {};
let updatedFields = {};

const DrugExclusionTable = (props) => {
  const API = useAxios()


    const {

        manvalConfig,
        manvalPharmacy,
        totalitem,
        data,
        orgId,
        refetch,
        filters,
        onSearchColumnFilters = () => '',
        onPageChange,
        fetchDrugExclusionAll,
        collapseSider,
        toggleSider,
        resetFilterFlag,
        SetResetFilterFlag,tabKey
    } = props;
    
    const [tableData, setTableData] = useState(tableDataBackup);
    const [isPODetailsOpen, setisPODetailsOpen] = useState(false);
    const [drawerPODetails, setDrawerPODetails] = useState('');
    const [isOpenView, setOpenView] = useState(false);
    const [isOpenHistory, setOpenHistory] = useState(false);
    const [selectedRow, setselectedRow] = useState({});
    const [selectedRowHistory, setSelectedRowHistory] = useState({});
    const [commentDrawer, setCommentDrawer] = useState(false);
    const [commentRowData, setCommentRowData] = useState({});
      const [columnFilters, setColumnFilters] = useState([]);
    const [modal, setModal] = useState(false);
    const [data1, setData] = useState([]);
    const [hasTouched, setTouched] = useState('');
    const [isConfirm, setConfirm] = useState(false);
    const [loading, setLoading] = useState(false)
    const [reasonErr, setReasonErr] = useState(false);

    const toggle = () => setModal(!modal);

    let ReasonEdit= [
        {
          "id":"2370",
          "label":"Orphan Drug"
        },
        {
          "id":"2400",
          "label":"Non-Covered Drug"
        }
      ]



    const togglePODetailsDrawer = () => {
        setisPODetailsOpen(!isPODetailsOpen);
        setDrawerPODetails('');
      };
      
    const toggleViewPODetailsDrawer = () => {
        setOpenView(!isOpenView);
      };
      const toggleAttachPODetailsDrawer = () => {
        setCommentDrawer(!commentDrawer);
      };
    const handleConfig = async (rowData) => {
         await manvalConfig();

    }
    const handelAddCoveredEntity = async (rowData) => {
        await manvalPharmacy();

   }
   const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
debugger;
    if (hasColFilter) {
        const colFilterOn = { ...filter, filters: colChangedFilter };
        onPageChange(colFilterOn, true);
    } else {
        onPageChange(filter);
    }
};
const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
debugger;
    if (hasColFilter) {
        const colFilterOn = { ...filter, filters: colChangedFilter };
        return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
};
const handleFilterCancel = () => {
    setColumnFilters([])
  refetch();
};
const handleSearchColumnFilters = (colFilter) => {

if (onSearchColumnFilters) {
    onSearchColumnFilters(colFilter);
     setColumnFilters(colFilter);
}
};

   
const editRow = (rowData, isEdit = true) => {
   debugger;
 console.log(rowData,"rOWdATA IN EDIT rOW   ");

    let tempData = [...data];
    console.log(tempData,"tempData in Edit Row")
    tempData = tempData.map((row) => {
      // debugger;
        row.isEdit = false;
        if (row.drugExclusionID === rowData?.drugExclusionID && isEdit) {
            row.isEdit = isEdit;
           // row.endDate=dateFormate(row.endDate)
            rowForEdit = row;
             console.log(rowForEdit,"rowForEdit in edit Row")
            console.log(row,"row in edit Row")
        }
        return row;
        
    });
    setTouched('');
    setReasonErr(false);
    updatedFields = {};
    setTableData(tempData);
};
const checkvalidation = (selectedvaluesonly) => {

   if ((selectedvaluesonly.reason == undefined || selectedvaluesonly.reason == null || selectedvaluesonly.reason == "")) {
      setReasonErr(true);
      return true;

  }
  else {
      return false;
  }

}

const handleSaveConfirmation = () => {
  setConfirm(!isConfirm);
};
const hasPermission = (code) => {
  return ModuleAccess("DRC", code);
}
   const renderEditButton = (rowData) => {
    // debugger;
    if (hasPermission('ED'))
        return <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => editRow(rowData)}
            title='Edit'

        >
            <HoverImage src={EditIcon}
                hoverSrc={EditHoverIcon}
                alt='' />
        </Button>
}
    
const renderCheckBox = (rowData, col) => {
  let radioButtonColor = rowData.status === "Inactive" ? "red" : (rowData.status == "Will Be Active" ?  "grey" :"green")  ;
  // const startDate = new Date(rowData.startDate); 
  // const today = new Date();
  // today.setHours(0, 0, 0, 0);

  // if (startDate > today) {
  //   radioButtonColor = "grey";
  // }

  return (
<Input
      className="text-primary p-0 text-decoration-none"
      type="radio"
      disabled
      style={{
        backgroundColor: radioButtonColor,
        borderColor: radioButtonColor,
      }}
    />
  );
};
    const cellRenderEdit = (rowData) => {
      if (hasPermission('ED'))
        if (rowData.isEdit) {
            return (
              <div className="d-flex align-items-center">
                <Button
                  className="text-primary p-0 text-decoration-none"
                  color="link"
                  onClick={savePanelUpdateRow}
                >
                  <HoverImage
                    key="SaveIcon"
                    src={SaveIcon}
                    hoverSrc={SaveHoverIcon}
                    alt=""
                  />
                </Button>
                <Button
                  className="text-primary p-0 text-decoration-none"
                  color="link"
                   onClick={() => editRow(rowData, false)}
                >
                  <HoverImage
                    key="CancelIcon"
                    src={CancleIcon}
                    hoverSrc={CancleHoverIcon}
                    alt=""
                  />
                </Button>
              </div>
            );
         }
        return (
            <div className='d-flex align-items-center'>
                {renderEditButton(rowData)}
            </div>
        );
    };
    const savePanelUpdateRow = async () => {
      debugger;
      // handleSaveConfirmation();
      if (checkvalidation(rowForEdit))
          return true;

      setLoading(true);

      const payload = { ...rowForEdit };
      payload.Reason = payload.reason;
      payload.EndDate = payload.endDate == "-" ? null : payload.endDate ;
      delete payload.isEdit;
      ;
      try {
          const result = await API.post(
              `SBTenant/${orgId.tenantID}/DrugCatalog/UpdateDrugExclusion`,
              payload,
              {
                  hasDefaultURL: true,
              },
          );

          if (result) {

              if (result.data.error) {
                  toast.error(result.data.message);
              }
              else {
                  toast.success('Drug Updated Successfully');
                  
              }
              setLoading(false);
              // refetch(accumualator,selectedHospital);
              fetchDrugExclusionAll(filters);
          }
      } catch (error) {
          console.log(error);
          setLoading(false);
      }
  };

    const updateRowValue = (value, col) => {
      debugger;
        const tempRow = { ...rowForEdit };
        tempRow[col] = value;
         rowForEdit = tempRow;
         console.log('Updated row:', rowForEdit);
      };
    const formatter = (row, col, formatterType,alwaysEditableCheckbox) => {
      if (formatterType == "date") {
        return (
          <CellEditRender
            row={row}
            col={col}
            formatterType={formatterType}
            onChange={updateRowValue}
            //hasTouched={hasTouched}
            endDateFormatter={true}
            alwaysEditableCheckbox={alwaysEditableCheckbox}
  
          />
        );
  
      }
       else if(formatterType =="DrugstatusList"){
            return (
                <CellEditRender
                reasonErr ={reasonErr}
                    row={row}
                    col={col}
                    formatterType={formatterType}
                    hasTouched={hasTouched}
                    onChange={updateRowValue}
                    // alwaysEditableCheckbox={alwaysEditableCheckbox}
                    listArray={ReasonEdit}
                    // drugexclusion={true}
                />
            );
        }
        else{
                return (
                    <CellEditRender
                        row={row}
                        col={col}
                        formatterType={formatterType}
                        onChange={updateRowValue}
                        // alwaysEditableCheckbox={alwaysEditableCheckbox}
                    />
                );
            }
      };
   
    
  const handleExport = async () => {
        debugger;
        setLoading(true);
        const filterObj = cloneDeep(filters);
        // filterObj.AccumulatorIDs = filterObj.accumulationIds;
        // delete filterObj.accumulationIds;
        if (columnFilters && columnFilters.length > 0) {
          filterObj.filters = [...filterObj.filters, ...columnFilters];
        }
    
        const { access_token } =
          JSON.parse(localStorage.getItem('pharmaforce')) || {};
    
          var additionalCriteria = {};
          additionalCriteria.IsSelectedColumn = false;
          additionalCriteria.OrgId = orgId.organizationID;
           // additionalCriteria.ContractId = 0;
        // additionalCriteria.POId = 0;
        // additionalCriteria.OpaId = 0;
        // additionalCriteria.CEId = 0;
        // additionalCriteria.ManufactureId = 0;
    
        var payload = {};
        payload.tenantID = orgId.tenantID
        payload.gridCode = "drugexclusion";
        payload.fileTypeCode = "csv";
        payload.criteria = JSON.stringify(filterObj);
        payload.additionalCriteria = JSON.stringify(additionalCriteria);
        const { data } = await API.post(`export/queue`, payload, {
          hasExport: true,
        });
        setLoading(false);
      //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
      //  onExport(action, initialFilters);
      };
    let mainCol = [
      {
        dataField: 'edit',
        text: 'Options',
        cellRenderer: (rowData) => cellRenderEdit(rowData),
        width: 100,
        show: true,
        disabled: true,
        action: true,
    },
      {
        dataField: "status",
        text: "Status",
        sort: false,
        width: 110,
        show: true,
        inputType: "text",
        hideColFilter: false,
        cellRenderer: (row) => cellRendererCheck(row?.status),
      },
      {
        dataField: "ndc",
        text: "NDC",
        sort: true,
        width: 120,
        show: true,
        inputType: "text",
        hideColFilter: false,
        cellRenderer: (row) => cellRendererCheck(row.ndc),
      },
      {
        dataField: "drugName",
        text: "Drug Name",
        sort: true,
        width: 250,
        show: true,
        inputType: "text",
        hideColFilter: false,
        cellRenderer: (row) => cellRendererCheck(row.drugName),
      },
      {
        dataField: "reason",
        text: "Reason",
        sort: true,
        width: 120,
        show: true,
        inputType: "text",
        edit: true,
        hideColFilter: false,
        cellRenderer: (row,col) => formatter(row,col,"DrugstatusList"),
    },
      {
        dataField: "startDate",
        text: "Effective Date",
        sort: true,
        width: 150,
        show: true,
        inputType: "date",
        hideColFilter: false,
        cellRenderer: (row) => dateFormate(row.startDate),
      },
      {
        dataField: "endDate",
        text: "End Date",
        sort: true,
        width: 140,
        // height: 200,
        show: true,
        inputType: "date",
        hideColFilter: false,
        cellRenderer: (rowData, col) =>(rowData.endDate!=null)?dateFormate(rowData.endDate): formatter(rowData, col, 'date'),
        edit: true,
      },
      
      
      {
        dataField: "userNotes",
        text: "Comments",
        sort: true,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: false,
        edit: true,
        cellRenderer: (rowData, col) => formatter(rowData, col, "text"),
      },
      {
        dataField: "modifiedByID",
        text: "Modified By",
        sort: false,
        width: 120,
        show: true,
        inputType: "text",
        hideColFilter: false,
        cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
      },
      {
        dataField: "modifiedDate",
        text: "Modified Date",
        sort: true,
        width: 110,
        show: true,
        inputType: "date",
        hideColFilter: false,
        cellRenderer: (row) => dateFormate(row.modifiedDate),
      },
      
    ];
   
    const handlePODetails = (row) => {
        setisPODetailsOpen(!isPODetailsOpen);
        setDrawerPODetails('OrderDetails');
      };
      const onHandleSort = (filter, hasColFilter) => {
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };
  return (
    
    <div>
       <h5 className="f-16 text-primary font-weight-700">
        Drug Exclusion Count ({totalitem}) 
      </h5>
      <hr/>
              <div
            // className='table-card scroll-table position-relative border-0 rounded pt-0'
            // fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
            className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={
          data.length > 0
            ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}`
            : "default"
        }
        >
            <ReactStrapTable
                id='drugexclusion-table'
                height={550}
                fixedColumn
                width={1200}
                data={data}
                columns={mainCol}
                hasPagination={data.length>0 ? true :false}
                onExport={handleExport}
                filters={filters}
                totalRecords={totalitem}
                pageSize={filters.pageSize}                 
                currentPage={filters.currentPage}
                handleSort={onHandleSort}
                onPageChange={onHandlePageChange}
                onPageSizeChange={onPageSizeChange}
                onFilterCancel={handleFilterCancel}
                onSearchColumnFilters={handleSearchColumnFilters}
                collapseSider={collapseSider}
                toggleSider={toggleSider}
                showtoggle={true}
                resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
                keytab={tabKey}
            />
        </div>
        {/* <Confirm
            isOpen={isConfirm}
            loading={loading}
            message='This change will be effective going forward, to reprocess charges in the past please submit a ticket to support@thepharmaforce.com'
            onToggle={handleSaveConfirmation}
            onCancel={handleSaveConfirmation}
            onContinue={savePanelUpdateRow}
        /> */}
        {/* <div className='d-flex'
        style={{alignItems:"center",justifyContent:"flex-start"}}>
          <div className='mt-1'>Status :  </div>
          <div className='d-flex ms-2 mt-1'
          style={{alignItems:"center"}}
          >
          <Input
              className="text-primary p-0 text-decoration-none ms-2 f-12"
              type="radio"
              disabled
              style={{ backgroundColor: "#179300", borderColor: "green" }}
          />
            <p className='ms-2 m-0'>Active </p>
       
          </div>
          <div className='d-flex ms-2 mt-1'
                    style={{alignItems:"center"}}

          >
          <Input
              className="text-primary p-0 text-decoration-none ms-2 f-12"
              type="radio"
              disabled
              style={{ backgroundColor: "red", borderColor: "red" }}
          />
            <p className='ms-2 m-0'>Inactive </p>
       
          </div>
          <div className='d-flex ms-2 mt-1' 
                    style={{alignItems:"center"}}
>
          <Input
              className="text-primary p-0 text-decoration-none ms-2 f-12"
              type="radio"
              disabled
              style={{ backgroundColor: "grey", borderColor: "grey" }}
          />
            <p className='ms-2 m-0'>Will Be Active</p>
       
          </div>
        </div> */}
        
      <Modal isOpen={modal} fade={false} toggle={toggle} className={props.className}>
        <ModalHeader toggle={toggle}><h5 className="f-15 text-primary font-weight-700 mt-2">
        McKesson Upload Order
    </h5></ModalHeader>
        <ModalBody>
<div>
   <Formik
        // initialValues={initialValues}
        // onSubmit={handleSubmit}
        // validationSchema={validationSchema}
        // enableReinitialize={true}
        children={(props) => {
          // const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
          return (
            <div hidden={""}>
              
              <Row sm={5}>
              
                <Col md={12} lg={12} sm={12} xs={12}>
                  {" "}
                  <FormGroup>
                    <Label for="file">Choose File</Label>
                    <Input
                      id="file"
                      name="file"
                      type="file"
                      placeholder="Enter Contact Person Name"
                      autoComplete="off"
                      value={""}
                      component={""}
                      // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                    />
                  </FormGroup>
                </Col>
                
              </Row>
              
            </div>
          );
        }}
      ></Formik>
      </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggle}>Load Order</Button>{' '}
        </ModalFooter>
      </Modal>

    </div>
  )
}

export default DrugExclusionTable
